<template>
  <div>
    <BaseTitle :title="$t('content.people')" :yearPeriode="titleData" />

    <v-card>
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.list_teacher') }}</div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div>
              <v-btn
                color="primary"
                class="btn-primary-custom mb-2 mb-md-0 mr-md-2"
                @click="dialogPopUp = true"
                v-if="
                  (isStudent === false && permissionButton('ROLE_ASSIGNMENT_LITE_VIEW')) ||
                    (isStudent === false && permissionButton('ROLE_PAGES_LITE_CREATE'))
                "
                >{{ $t('content.invite') }}</v-btn
              >
            </div>
            <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
            <div>
              <v-text-field v-model="search" :label="$t('search')" @input="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <div class="border-item" v-for="item in datas" :key="item.userId">
          <v-row class="border-item">
            <v-col md="1" align="center">
              <div class="mt-5 ml-5">
                <svg-icon icon="ic-school" width="30" height="30" class="primary--text" />
                <v-divider vertical></v-divider>
              </div>
            </v-col>
            <v-col md="10" class="mt-3">
              <div class="d-block">
                <h3 class="d-inline">
                  <span class="header-content">{{ item.fullName }} </span>
                </h3>
              </div>
              <div class="d-block">
                <div>
                  <span class="body-content">
                    <span class="mr-3">
                      {{ $t('content.join_class') }} :
                      <strong>{{ item.joinClass }}</strong>
                    </span>
                    |
                    <span class="mr-3">
                      {{ $t('form.email') }} :
                      <strong>{{ item.email }}</strong>
                    </span>
                  </span>
                </div>
              </div>
              <div class="d-flex"></div>
            </v-col>
          </v-row>
        </div>
        <NoData v-if="!datas.length" />
      </div>
    </v-card>
    <v-card class="mt-6">
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.list_student') }}</div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div>
              <v-text-field v-model="searchStudent" :label="$t('search')" @input="getDataStudent">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>

              <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary" />
            </div>
          </div>
        </div>
        <div class="border-item" v-for="item in datasStudent" :key="item.userId">
          <v-row class="border-item">
            <v-col md="1" align="center">
              <div class="mt-5 ml-5">
                <svg-icon icon="ic-school" width="30" height="30" class="primary--text" />
                <v-divider vertical></v-divider>
              </div>
            </v-col>
            <v-col md="10" class="mt-3">
              <div class="d-block">
                <h3 class="d-inline">
                  <span class="header-content">{{ item.fullName }} </span>
                </h3>
              </div>
              <div class="d-block">
                <div>
                  <span class="body-content">
                    <span class="mr-3">
                      {{ $t('content.join_class') }} :
                      <strong>{{ item.joinClass }}</strong>
                    </span>
                    |
                    <span class="mr-3">
                      {{ $t('form.email') }} :
                      <strong>{{ item.email }}</strong>
                    </span>
                  </span>
                </div>
              </div>
              <div class="d-flex"></div>
            </v-col>
          </v-row>
        </div>
        <NoData v-if="!datasStudent.length" />
      </div>
    </v-card>
    <!-- Dialog Join Class lite -->
    <v-dialog v-model="dialogPopUp" persistent max-width="607">
      <v-card>
        <v-card-title class="headline secondary white--text">
          {{ $t('content.modal_people_title') }}
        </v-card-title>
        <v-card-subtitle class="headline d-flex justify-center pa-5">
          <v-row>
            <v-col cols="12" md="12" class="py-0">
              <div class="join-class pa-3 mt-2 mb-2">
                <strong class="text-join"> {{ $t('content.modal_people_content') }}</strong>
              </div>
            </v-col>
            <v-col cols="12" md="12" class="py-0">
              <form-group :name="$t('form.email')" :validator="$v.form.email">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.email"
                    v-bind="attrs"
                    :label="$t('form.email')"
                    @input="$v.form.email.$touch()"
                    @blur="$v.form.email.$touch()"
                  />
                </template>
              </form-group>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer />
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="clearDatas">{{ $t('back') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" type="submit" @click="inviteTeacherCheck">{{ $t('content.invite') }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog Confirm lite -->
    <v-dialog v-model="dialogPopUpConfirm" persistent max-width="607">
      <v-card>
        <v-card-title class="headline secondary white--text">
          {{ $t('content.modal_people_title') }}
        </v-card-title>
        <v-card-subtitle class="headline d-flex justify-center pa-5">
          <v-row>
            <v-col md="6">
              <div class="app-section-title ml-3">{{ $t('content.user_upload_title') }}</div>
              <image-box :upload-btn-text="$t('upload')" :image-preview="teacherData.imageUrl" class="mt-4" />
            </v-col>
            <v-col md="6">
              <v-col md="12">
                <div class="d-block">
                  <strong class="title-dialog">
                    {{ $t('content.name_teacher') }}
                  </strong>
                </div>
                <div class="d-block ">
                  <span class="title-dialog">
                    {{ teacherData.fullName }}
                  </span>
                </div>
              </v-col>
              <v-col md="12">
                <div class="d-block">
                  <strong class="title-dialog">
                    {{ $t('form.email') }}
                  </strong>
                </div>
                <div class="d-block ">
                  <span class="title-dialog">
                    {{ form.email }}
                  </span>
                </div>
              </v-col>
              <v-col md="12">
                <div class="d-block">
                  <strong class="title-dialog">
                    {{ $t('form.school_name') }}
                  </strong>
                </div>
                <div class="d-block ">
                  <span class="title-dialog">
                    {{ teacherData.schoolName }}
                  </span>
                </div>
              </v-col>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer />
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="clearDatas">{{ $t('back') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" type="submit" @click="inviteTeacher">{{ $t('submit') }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog Success -->
    <v-dialog v-model="dialogPopUpSuc" persistent max-width="607">
      <v-card>
        <div class="d-flex justify-center">
          <svg-icon icon="succ-add" class="mt-10 mb-10" width="200" height="120" />
        </div>
        <v-card-title class="headline d-flex justify-center">{{ $t('content.modal_people_suc_title') }} </v-card-title>
        <v-card-text class="d-flex justify-center">{{ $t('content.modal_people_suc_content') }}</v-card-text>
        <v-card-text class="d-flex justify-center">
          <v-btn color="primary" class="btn-primary-custom" @click="dialogPopUpSuc = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPopUpNotRegister" persistent max-width="607">
      <v-card class="pa-5">
        <div class="d-flex justify-center">
          <svg-icon icon="ic-failed" width="180" height="121" class="mt-5 mb-5" />
        </div>
        <v-card-title class="headline d-flex justify-center" v-if="isFound === false">{{ $t('content.teacher_invite_idle_1') }}</v-card-title>
        <v-card-title class="headline d-flex justify-center" v-else>{{ $t('content.teacher_invite_idle') }}</v-card-title>
        <v-card-text class="d-flex justify-center mb-5">{{ $t('content.another_email') }}</v-card-text>
        <v-card-text class="d-flex justify-center">
          <v-btn color="primary" class="btn-primary-custom" @click="clearDatas">
            {{ $t('close') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';
import ImageBox from '@/components/ImageBox';

export default {
  name: 'ListTeacherIndex',
  components: {
    BaseTitle,
    NoData,
    ImageBox
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    }
  },
  validations: function() {
    return {
      form: {
        email: { required, email }
      }
    };
  },
  computed: {
    ...mapGetters({
      course: 'QuizTeacher/courses',
      classLevel: 'QuizTeacher/classLevel',
      permission: 'Auth/permission',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    })
  },
  data: () => ({
    loadingButton: false,
    loadingLoad: false,
    dialogPopUp: false,
    dialogPopUpConfirm: false,
    dialogPopUpSuc: false,
    dialogPopUpNotRegister: false,
    isFound: false,
    dataClass: '',
    datas: '',
    datasStudent: '',
    search: '',
    searchStudent: '',
    currentItem: '',
    form: {
      email: ''
    },
    teacherData: '',
    titleData: ''
  }),
  methods: {
    clearDatas() {
      this.form.email = '';
      this.teacherData = '';
      this.dialogPopUp = false;
      this.dialogPopUpConfirm = false;
      this.dialogPopUpNotRegister = false;
      this.$v.form.$reset();
    },
    inviteTeacher() {
      this.loading = true;
      const payload = { ...this.form, classroomId: this.$route.params.classId, courseId: this.$route.params.courseId };

      this.$store
        .dispatch(`ListLite/inviteTeacher`, payload)
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => {
          this.loading = false;
          this.dialogPopUp = false;
          this.dialogPopUpConfirm = false;
          this.dialogPopUpSuc = true;
          this.getData();
          this.getDataStudent();
          this.form.email = '';
          this.teacherData = '';
          this.$v.form.$reset();
        });
    },
    inviteTeacherCheck() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return false;
      }
      this.loading = true;
      const payload = { ...this.form, classroomId: this.$route.params.classId, courseId: this.$route.params.courseId };

      this.$store
        .dispatch(`ListLite/inviteTeacherCheck`, payload)
        .catch(err => {
          const code = err?.response?.data?.errorMessages;
          if (code === 'Email tidak terdaftar') {
            this.isFound = true;
            this.dialogPopUpNotRegister = true;
          } else {
            this.isFound = false;
            this.dialogPopUpNotRegister = true;
          }
        })
        .then(res => {
          if (res) {
            this.loading = false;
            this.dialogPopUp = false;
            this.dialogPopUpConfirm = true;
            this.teacherData = res;
          }
        });
    },
    permissionButton(push) {
      return this.permission.some(p => p === push) ?? false;
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('ListLite/getDataAllTeacher', {
          classroomId: this.$route.params.classId,
          courseId: this.$route.params.courseId,
          search: this.search
        })
        .then(res => {
          if (res) {
            this.datas = res;
          }
        })
        .finally(() => {
          this.loadingLoad = false;
        });
    },
    getDataStudent() {
      this.loadingLoad = true;
      this.$store
        .dispatch('ListLite/getDataAllStudent', {
          classroomId: this.$route.params.classId,
          courseId: this.$route.params.courseId,
          search: this.searchStudent
        })
        .then(res => {
          if (res) {
            this.datasStudent = res;
          }
        })
        .finally(() => {
          this.loadingLoad = false;
        });
    }
  },
  created() {
    this.getData();
    this.getDataStudent();
    if (this.isClass) {
      this.getDataClass();
    } else {
      localStorage.removeItem('courseName');
    }
  }
};
</script>

<style lang="scss" scoped>
.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.fixed-card {
  margin-top: 500px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 7px 16px 0 rgba(0, 0, 0, 0.13);
}

.join-class {
  background-color: #b2ebd0;
  border-radius: 8px;
}

.text-join {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
}

.title-dialog {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
</style>
